<div class="sip-manipulation-groups">
    <legend>SIP Manipulation Groups</legend>
    <arm-layout [summaryTitle]="'SIP manipulation groups summary'" class="sip-manipulation-groups-layout">
        <div header>
            <div class="search-and-actions">
                <div class="search-container">
                    <client-filter (onFilter)="onFilter($event)"></client-filter>
                </div>

                <div class="action-buttons">
                    <arm-action-bar (addClick)="addItem()" [disableAdd]="isUnauthorized"
                                    (refreshClick)="refresh()"
                                    (deleteClick)="removeItem()" [disableDelete]="!selection || isUnauthorized"
                                    (editClick)="editItem()" [disableEdit]="!selection || isUnauthorized">
                    </arm-action-bar>
                </div>
            </div>

            <div class="action-buttons">
                <arm-action-bar (addClick)="addItem()" [disableAdd]="isUnauthorized" (deleteClick)="removeItem()"
                                [disableDelete]="isUnauthorized || !selection || selection.length === 0"
                                (refreshClick)="refresh()" (editClick)="editItem()"
                                [disableEdit]="isUnauthorized || !selection || selection.length === 0"></arm-action-bar>
            </div>
        </div>
        <div summary>
            <sip-manipulation-groups-summary [selection]="selection"></sip-manipulation-groups-summary>
        </div>

        <div main>
            <arm-table [displayedColumns]="displayedColumns"
                       (onSelection)="onSelection($event)" [data]="items"
                       [isMultipleSelection]="false"
                       [isClientSide]="true" [filter]="filter"></arm-table>
        </div>
    </arm-layout>
</div>

